import settings from "./settings.json";
import common from "./common.json";

export default {
  settings,
  common,
};
